import { useState } from 'react';

import { useMe } from '@/hooks/use-me';
import { clipboardWrite } from '@/utils/dom/clipboard-write';

const wait = (t: number) => new Promise((r) => setTimeout(r, t));

export function useEmail(): [string, () => Promise<void>, boolean] {
  const me = useMe();
  const [nbCopies, setNbCopies] = useState<number>(0);

  const email = `${me.tenant.replaceAll('_', '-')}@accure-platform.com`;

  async function copyEmail() {
    await clipboardWrite(email);
    setNbCopies((n) => n + 1);
    await wait(2000);
    setNbCopies((n) => n - 1);
  }

  const isCopied = nbCopies > 0;

  return [email, copyEmail, isCopied];
}
